module.exports = __webpack_public_path__ + "static/media/lock-white.3b2b80c8.svg";